import { render, staticRenderFns } from "./poster-form.vue?vue&type=template&id=352fd9ec&"
import script from "./poster-form.vue?vue&type=script&lang=js&"
export * from "./poster-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports